module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 console.log(content) 
__p+='\n';
 var productsData = content.productdata 
__p+='\n';
 if (productsData.length) { 
__p+='\n    ';
 _.each(content.specs, function(spec){ 
__p+='\n        ';
 var specHandle = spec.spec 
__p+='\n        ';
 var specLable = spec.label 
__p+='\n        <div class="row col-wrapper">\n            <div class="col compare-all-labels">\n                <div class="label-spec" data-spec="'+
((__t=( specHandle ))==null?'':__t)+
'" >'+
((__t=( specLable ))==null?'':__t)+
'</div>\n            </div>\n            <div class="col compare-all-grid">\n            ';
 for (var i = 0; i < content.maxCompareNum; i++) { 
__p+='\n                ';
 if ( typeof productsData[i] === 'undefined' ) { 
__p+='\n                    <div class="item empty" ></div>\n                ';
 } else { 
__p+='\n                    <div class="item" data-id="'+
((__t=( productsData[i].id ))==null?'':__t)+
'" data-spec="'+
((__t=( specHandle ))==null?'':__t)+
'">\n                        <p>'+
((__t=( productsData[i][specHandle] ))==null?'':__t)+
'</p>\n                    </div>\n                ';
 } 
__p+='\n            ';
 } 
__p+='\n            </div>\n        </div>\n    ';
 }) 
__p+='\n';
 } 
__p+='';
}
return __p;
};
